import React from 'react'
import { useTranslation } from 'react-i18next'

import PageTitle from './PageTitle'

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <div data-testid="content-notfound">
      <PageTitle label={t('notFound.title')} />
      {t('notFound.content')}
    </div>
  )
}
